<template>
  <div class="control-panel" :class="{ 'old_survey_type': question.type === 'select_image' }">
    <div v-if="question.type === 'select_image'" class="control-panel__section control-panel__section--left">
      <a
          v-if="showProductsBtn && question.type === 'select_image'"
          href="#"
          class="control-panel__btn control-panel__btn_products"
          @click.stop.prevent="$emit('toggleProducts')"
      >
        <span class="control-panel__btntext">Show Products</span>
      </a>
      <span
          v-else
          href="#"
          class="control-panel__btn control-panel__btn_products control-panel__btn_products--disabled"
          @click.stop.prevent
      >
        <span class="control-panel__btntext">Show Products</span>
      </span>
    </div>

    <div class="control-panel__section control-panel__section--center">
      <div class="control-panel__element control-panel__element--nav">
        <a
            href="#"
            class="control-panel__btn control-panel__btn_prev"
            :class="{ 'control-panel__btn--disabled': isFirst }"
            @click.stop.prevent="$emit('prev')"
        >
          <span class="control-panel__btntext">{{ prevText }}</span>
        </a>
      </div>

      <div v-if="question.type === 'select_image'" class="control-panel__element">
        <a
            href="#"
            :class="{ 'control-panel__btn--active': question.last_answer === 1, 'control-panel__btn--hot': current_answer === 1 }"
            class="control-panel__btn control-panel__btn--answers"
            @click.stop.prevent="answer(1)"
        >
          <span class="control-panel__btntext">1</span>
        </a>
        <span class="control-panel__helptext">{{ dislikeText }}</span>
      </div>

      <div v-if="question.type === 'select_image'" class="control-panel__element">
        <a
            href="#"
            :class="{ 'control-panel__btn--active': question.last_answer === 2, 'control-panel__btn--hot': current_answer === 2 }"
            class="control-panel__btn control-panel__btn--answers"
            @click.stop.prevent="answer(2)"
        >
          <span class="control-panel__btntext">2</span>
        </a>
      </div>

      <div v-if="question.type === 'select_image'" class="control-panel__element">
        <a
            href="#"
            :class="{ 'control-panel__btn--active': question.last_answer === 3, 'control-panel__btn--hot': current_answer === 3 }"
            class="control-panel__btn control-panel__btn--answers"
            @click.stop.prevent="answer(3)"
        >
          <span class="control-panel__btntext">3</span>
        </a>
        <span class="control-panel__helptext">{{ likeText }}</span>
      </div>

      <div v-if="question.type === 'select_image'" class="control-panel__element">
        <a
            href="#"
            :class="{ 'control-panel__btn--active': question.last_answer === 4, 'control-panel__btn--hot': current_answer === 4 }"
            class="control-panel__btn control-panel__btn--answers"
            @click.stop.prevent="answer(4)"
        >
          <span class="control-panel__btntext">4</span>
        </a>
      </div>

      <div v-if="question.type === 'select_image'" class="control-panel__element">
        <a
            href="#"
            :class="{ 'control-panel__btn--active': question.last_answer === 5, 'control-panel__btn--hot': current_answer === 5 }"
            class="control-panel__btn control-panel__btn--answers"
            @click.stop.prevent="answer(5)"
        >
          <span class="control-panel__btntext">5</span>
        </a>
        <span class="control-panel__helptext">{{ loveText }}</span>
      </div>

      <div class="control-panel__element control-panel__element--nav">
        <a
            href="#"
            class="control-panel__btn control-panel__btn_next"
            v-tooltip="{
              content: 'An answer is required',
              show: nextClickedNoAnswer,
              trigger: 'manual',
            }"
            :class="{ 'control-panel__btn--disabled': isLast, 'required-error': nextClickedNoAnswer }"
            @click.stop.prevent="clickNext"
        >
          <span class="control-panel__btntext">{{ nextText }}</span>
        </a>
      </div>
    </div>

    <div v-if="!hideEndSurvey" class="control-panel__section control-panel__section--right">
      <a
          href="#"
          class="control-panel__btn control-panel__btn_end"
          @click.stop.prevent="$emit('endSurvey')"
      >
        <span class="control-panel__btntext">End Survey</span>
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    nextText: {
      type: String,
      default: "Next"
    },
    prevText: {
      type: String,
      default: "Prev"
    },
    hideEndSurvey: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => { return {type: ""}
      },
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    showProductsBtn: {
      type: Boolean,
      default: false,
    },
    isVisualSurvey: {
      type: Boolean,
      default: false,
    },
    disableRequired: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      current_answer: null,
      nextClickedNoAnswer: false,
    }
  },
  computed: {
    ...mapGetters('take_survey', ['tempInput']),
    dislikeText() {
      return this.isVisualSurvey ? "Dislike" : "Disagree"
    },
    likeText() {
      return this.isVisualSurvey ? "Like" : "Indifferent"
    },
    loveText() {
      return this.isVisualSurvey ? "Love" : "Agree"
    },
    isAnswer() {
      const isValue = function(input) {
        if (Array.isArray(input)) {
          return input.length > 0
        } else {
          return Boolean(input)
        }
      }
      if (this.tempInput && this.tempInput.answer) {
        return isValue(this.tempInput.answer)
      } else if (this.question.answer) {
        return isValue(this.question.answer)
      } else if (this.question.last_answer) {
        return isValue(this.question.last_answer)
      }
      return false
    }
  },
  methods: {
    clickSubmit() {
      this.$emit('click-submit')
    },
    clickNext() {
      if (!this.disableRequired && !this.isAnswer) {
        this.nextClickedNoAnswer = true
        setTimeout(() => { this.nextClickedNoAnswer = false }, 1000)
      } else {
        this.$emit('next')
      }
    },
    answer(val) {
      if (!this.current_answer) {
        this.current_answer = val
        setTimeout(() => {
          this.current_answer = null
          this.$emit('answer', {'answer': val})
        }, 500)
      }
    },
  },
}
</script>
<style scoped lang="scss">
.control-panel__btn_submit {
  width: 150px;
  background-color: #337ab7;
  border-color: #2e6da4;
  color: white;


  &:hover {

  }
}

.required-error {
    animation: error 1s;
  }

  @keyframes error {
  0% {
    border: 3px solid #c76e69;
  }
  50% {
    border: 3px solid red;
    color: red;
  }
  100% {
    border: 3px solid #c76e69;
  }
}
</style>
